module.exports = __webpack_public_path__ + "static/img/Jordan-Mclean.0dd35a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jordan-Mclean.jpg
// module id = YKY/
// module chunks = 0